import { CSidebarBrand } from "@coreui/react";
import Logo from "../../assets/images/LogoImage.jpg";
import React from "react";
import { useNavigate } from "react-router-dom";

const NavbarLogo = () => {
  const navigate = useNavigate();
  return (
    <CSidebarBrand className="text-decoration-none  logo-wrapper " to="/">
      <div
        className=" cursor-pointer logo-container "
        onClick={() => navigate("/dashboard")}
      >
        <img src={Logo} className="logo-img " />
      </div>
    </CSidebarBrand>
  );
};

export default NavbarLogo;
